namespace advisorop.components.servicer {


    export class ExtinterfacesSetupController {

        advisoryFirmId: number;
        lovs: Array<domains.ILOV> = [];
        extinterfaceTypes: Array<domains.ILOV> = [];
        selExtinterfaceType: domains.ILOV;
        allExtinterfaces: Array<domains.ILOV> = [];
        extinterfaces: Array<domains.ILOV> = [];
        selExtinterface: domains.ILOV;
        public dgExtinterfaces: DevExpress.ui.dxDataGridOptions;
        showExtinterfacePanel: boolean = false;

        extinterface: domains.IAFExtinterface = {};
        afExtinterfaces: domains.IAFExtinterface[] = [];

        static $inject = ["servicerService", "generalService"];
        constructor(private servicerService: services.ServicerService,
            private generalService: services.GeneralService) {
            this.dgExtinterfaces = {
                export: {
                    enabled: true,
                    fileName: "AFExtInterfaces"
                },
                bindingOptions: {
                    dataSource: "vm.afExtinterfaces",
                },
                paging: { pageSize: 10 },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: false,
                allowColumnReordering: false,
                noDataText: "There are no external interfaces",
                allowColumnResizing: false,
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: false },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: true,
                    width: 240,
                    placeholder: "Search..."
                },
                wordWrapEnabled: true,
                columns: [
                    { dataField: "extinterfaceTypeDescription", caption: "Interface Domain" },
                    { dataField: "extinterfaceDescription", caption: "Interface" },
                    { dataField: "status", caption: "Active", cellTemplate: "colActive" },
                    { dataField: "id", caption: "Actions", cellTemplate: "btnActions", width: "150" }
                ],

            };
        }

        cancelAssignExtinterface(): void {
            this.selExtinterfaceType = null;
            this.showExtinterfacePanel = false;
        }

        cleanInputs(): void {
            this.cancelAssignExtinterface();
        };

        loadFirmExtinterfaces(): void {
            this.servicerService.getFirmExtinterfaces(this.advisoryFirmId)
                .then((response) => {
                    this.afExtinterfaces = response.data;
                    this.dgExtinterfaces.dataSource = this.afExtinterfaces;
                })
                .catch(err => {
                    toastr.error("Cannot fetch firm external interfaces!");
                });
        };

        addAFExtinterface(): void {
            let tmpExtinterface = this.extinterface;
            tmpExtinterface.id = 0;
            tmpExtinterface.advisoryFirmId = this.advisoryFirmId;
            tmpExtinterface.extinterface = this.selExtinterface.value;
            tmpExtinterface.extinterfaceType = this.selExtinterfaceType.value;
            tmpExtinterface.status = domains.Status.ACTIVE;

            this.servicerService.addFirmExtinterface(tmpExtinterface)
                .then((response) => {
                    toastr.success("External interface successfully added.");
                    this.loadFirmExtinterfaces();
                    this.cleanInputs();
                }, err => toastr.error("External interface has not been added! " + err.data));
        };

        disableAFExtinterface(ei: domains.IAFExtinterface): void {
            this.servicerService.disableFirmExtinterface(ei.id)
                .then((response) => {
                    toastr.success("External interface successfully disabled.");
                    this.loadFirmExtinterfaces();
                }, err => toastr.error("External interface has not been disabled! " + err.data));
        };

        enableAFExtinterface(ei: domains.IAFExtinterface): void {
            this.servicerService.enableFirmExtinterface(ei.id)
                .then((response) => {
                    toastr.success("External interface successfully enabled.");
                    this.loadFirmExtinterfaces();
                }, err => toastr.error("External interface has not been enabled! " + err.data));
        };

        deleteAFExtinterface(ei: domains.IAFExtinterface): void {
            this.servicerService.deleteFirmExtinterface(ei.id)
                .then((response) => {
                    toastr.success("External interface successfully deleted.");
                    this.loadFirmExtinterfaces();
                }, err => toastr.error("External interface has not been deleted! " + err.data));
        };

        extinterfaceTypeChanged(): void {
            if (this.selExtinterfaceType) {
                this.extinterfaces = this.allExtinterfaces.filter(v => v.lovType == domains.LovType.EXTERNAL_SYSTEM && v.parentId == this.selExtinterfaceType.value);
                if (this.extinterfaces.length > 0) {
                    this.showExtinterfacePanel = true;
                }
            } else {
                this.extinterfaces = [];
            }
        };

        loadLovs(): void {
            this.generalService.getLOVs()
                .then(data => {
                    this.extinterfaceTypes = (<domains.ILOV[]>data).filter(v => { return v.lovType == domains.LovType.EXTERNAL_SYSTEM_TYPE; });
                    this.allExtinterfaces = (<domains.ILOV[]>data).filter(v => { return v.lovType == domains.LovType.EXTERNAL_SYSTEM; });
                }, (reason) => {
                    toastr.error("Error " + reason);
                });
        };

        $onInit(): void {
            this.loadLovs();
        }

        $onChanges(evt): void {
            for (var key in evt) {
                if (key === "advisoryFirmId") {
                    if (this.advisoryFirmId && this.advisoryFirmId > 0) {
                        this.loadFirmExtinterfaces();
                    }
                }
            }
        }

    }


    class ExtinterfacesSetup implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                advisoryFirmId: "<"
            };
            this.controller = ExtinterfacesSetupController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/servicer-module/components/extinterfaces-setup.html";
        }
    }
    angular.module(Constants.APP).component("extinterfacesSetup", new ExtinterfacesSetup());
}